/**
 * LDM · Oferta por cantidad
 * ---------------------------------------------------------------------------
 * Sincroniza el tier seleccionado con:
 *   - el input `quantity` del form de producto
 *   - la line item property `_bundle` (para etiquetar el pedido)
 *   - el texto del botón de compra
 *   - la barra de compra persistente, vía el evento `ldm:tier-change`
 *
 * No calcula descuentos: eso lo hacen los descuentos automáticos de Shopify.
 *
 * Nota: los tiers son <label> que envuelven un radio. Escuchamos `change` del
 * radio y no `click` del label — asignar `checked` por código dentro de un
 * label dispara un click sintético que reentraría en esta misma función.
 */
(function () {
  'use strict';

  function initOffer(root) {
    if (root.dataset.ldmInit === 'true') return;
    root.dataset.ldmInit = 'true';

    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-ldm-tier]'));
    var qtyInput = root.querySelector('[data-ldm-qty-input]');
    var bundleInput = root.querySelector('[data-ldm-bundle-input]');
    var ctaText = root.querySelector('[data-ldm-cta-text]');
    var baseLabel = ctaText ? ctaText.textContent.trim() : '';

    if (!tiers.length || !qtyInput) return;

    function apply(tier) {
      if (!tier) return;

      tiers.forEach(function (t) {
        t.classList.toggle('is-selected', t === tier);
      });

      var qty = parseInt(tier.dataset.qty, 10) || 1;
      var price = tier.dataset.priceDisplay || '';
      var bundle = tier.dataset.bundleLabel || '';

      qtyInput.value = qty;
      if (bundleInput) bundleInput.value = bundle;
      if (ctaText && price) ctaText.textContent = baseLabel + ' — ' + price;

      actualizarRegalo(root, qty);

      document.dispatchEvent(
        new CustomEvent('ldm:tier-change', {
          detail: { quantity: qty, price: price, label: bundle }
        })
      );
    }

    tiers.forEach(function (tier) {
      var radio = tier.querySelector('.ldm-qo__radio-native');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (radio.checked) apply(tier);
      });
    });

    // Estado inicial: el tier que el schema dejó preseleccionado.
    var start =
      tiers.filter(function (t) {
        var r = t.querySelector('.ldm-qo__radio-native');
        return r && r.checked;
      })[0] ||
      root.querySelector('[data-ldm-tier].is-selected') ||
      tiers[0];

    apply(start);

    /**
     * Blindaje ante apps de bundles.
     *
     * Kaching (y otras apps del mismo tipo) detectan cualquier form de producto
     * e inyectan sus propios campos, sobrescribiendo `quantity`. Reafirmamos
     * nuestro valor justo antes de enviar y retiramos los campos ajenos, para
     * que la cantidad que se agrega sea siempre la que el usuario eligió.
     */
    var form = root.querySelector('form');
    if (form) {
      form.addEventListener(
        'submit',
        function () {
          var selected =
            root.querySelector('[data-ldm-tier].is-selected') || start;
          if (selected) {
            qtyInput.value = parseInt(selected.dataset.qty, 10) || 1;
            if (bundleInput) {
              bundleInput.value = selected.dataset.bundleLabel || '';
            }
          }
          form
            .querySelectorAll('input[name^="properties[__kaching"]')
            .forEach(function (el) {
              el.parentNode.removeChild(el);
            });
        },
        true
      );

      compraDirecta(root, form, function () {
        return root.querySelector('[data-ldm-tier].is-selected') || start;
      });
    }
  }

  /**
   * Compra directa: agrega y lleva al pago en un paso.
   *
   * Se agrega por `fetch` en vez de enviar el formulario porque el envío normal
   * termina en el carrito, y aquí el sentido es saltárselo. Se arma el cuerpo a
   * mano con la variante y la cantidad del tier elegido, de modo que los campos
   * que las apps de bundles inyectan en el formulario no viajen.
   */
  function compraDirecta(root, form, tierActual) {
    var boton = root.querySelector('[data-ldm-buy-now]');
    if (!boton) return;

    var textoEl = boton.querySelector('[data-ldm-buy-now-text]');
    var textoBase = textoEl ? textoEl.textContent.trim() : '';
    var enCurso = false;

    boton.addEventListener('click', function () {
      if (enCurso) return;

      var variante = form.querySelector('input[name="id"]');
      if (!variante || !variante.value) return;

      var tier = tierActual();
      var qty = tier ? parseInt(tier.dataset.qty, 10) || 1 : 1;
      var props = {};
      if (tier && tier.dataset.bundleLabel) props._bundle = tier.dataset.bundleLabel;

      enCurso = true;
      boton.disabled = true;
      if (textoEl) textoEl.textContent = 'Un momento…';

      fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variante.value), quantity: qty, properties: props }]
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('No se pudo agregar');
          window.location.href = '/checkout';
        })
        .catch(function () {
          // Si falla, se devuelve el control en lugar de dejar el botón colgado.
          enCurso = false;
          boton.disabled = false;
          if (textoEl) textoEl.textContent = textoBase;
        });
    });
  }

  /**
   * Estado del regalo por volumen.
   *
   * Mientras la cantidad elegida no llega al mínimo, el aviso dice cuánto falta
   * y se ve apagado; al alcanzarlo cambia el texto, se marca en verde y el icono
   * pasa de caja a check con un rebote breve. Sin esto el mismo mensaje aparecía
   * con 1 unidad que con 3 y no se entendía que el regalo se activaba.
   */
  function actualizarRegalo(root, qty) {
    var gift = root.querySelector('[data-ldm-gift]');
    if (!gift) return;

    var min = parseInt(gift.dataset.giftMin, 10) || 2;
    var textoEl = gift.querySelector('[data-ldm-gift-text]');
    var desbloqueado = qty >= min;
    var yaEstaba = gift.classList.contains('is-unlocked');

    if (textoEl) {
      var txt = desbloqueado ? gift.dataset.giftUnlocked : gift.dataset.giftLocked;
      if (!desbloqueado && txt) {
        var faltan = min - qty;
        txt = txt.replace('{n}', faltan);
      }
      if (txt) textoEl.textContent = txt;
    }

    gift.classList.toggle('is-unlocked', desbloqueado);

    // El rebote solo en la transición de bloqueado a desbloqueado, no en cada
    // repintado: repetirlo en cada clic resultaría ruidoso.
    if (desbloqueado && !yaEstaba) {
      gift.classList.remove('ldm-celebra');
      void gift.offsetWidth;
      gift.classList.add('ldm-celebra');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ldm-quantity-offer]').forEach(initOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // El editor de temas reinyecta secciones sin recargar la página.
  document.addEventListener('shopify:section:load', initAll);
})();
